/***
 * Where custom events/analytics should live
 */


(function($){
    let params = new URLSearchParams(document.location.search);

    function should_log(){
        return /[?&]showlogging/.test(location.search);
    }

    function start_group(group){
        if(should_log()) {
            console.group(group);
        }
    }

    function write_log(logInfo){
        if(should_log()){
            console.log(logInfo);
        }
    }

    function end_group(){
        if(should_log()){
            console.groupEnd();
        }
    }

    $(function(){

        $('a[href^="tel:"]').on('click', function(){
            const number = $(this).attr('href');

            // Google Ads custom conversion tag
            gtag('event', 'conversion', {
                'send_to': 'AW-787129501/WzsnCM3sm8ABEJ3JqvcC',
            });

            // Generic GA Call
            gtag('event', 'clickToCall', {
                'event_category': 'Phone',
                'event_label': number
            });

            start_group('Telephone Click');
            write_log("gtag('event', 'conversion', {'send_to': 'AW-787129501/WzsnCM3sm8ABEJ3JqvcC',});");
            write_log("gtag('event', 'clickToCall', {'event_category': 'Phone','event_label': '"+number+"'});");
            write_log({'Click to call': number});
            end_group();
        });


        // Capture external links (this usually triggers the modal)
        $('a[href*="//"]:not([href*="mtcfederal.local:8000"], [href*="https://www.mtcfederal.com"], [href*="https://www.netteller.com"])').on('click', function(){
            start_group('Capture Exit');
            const goingTo = $(this).attr('href');

            gtag('event', 'attemptToLeave', {
                'event_category': 'External Link',
                'event_label': goingTo
            });

            write_log("gtag('event', 'attemptToLeave', {'event_category': 'External Link','event_label': '" + goingTo + "'});");
            end_group();
            setTimeout(listen_for_confirmation, 500, goingTo);
        });

        // Used by setTimeout because jAlert injects the dom magically & events get snarfed
        function listen_for_confirmation(goingTo) {
            $('.jAlert .confirmBtn').bind('click', function () {
                start_group('Confirm Exit');
                gtag('event', 'proceedToUrl', {
                    'event_category': 'External Link',
                    'event_label': goingTo
                });
                write_log("gtag('event', 'proceedToUrl', {'event_category': 'External Link', 'event_label': '" + goingTo + "'});");
                end_group();
            });
        }

    });

    if(should_log()){
        console.log('LOGGING ENABLED');
    }

})(jQuery);